import { Button, CircularProgress, Grid, Modal, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import { get, includes } from "lodash";
import { useState } from "react";
import BSInput from "../../../common/js/components/BSInput";
import schema from "../admin/userListingsTable";

const StyledModalContent = styled("div")(() => ({
    display: "flex",
    width: "50%",
    marginLeft: "30%",
    background: "white",
    padding: "2vh 0 5vh 0",
    flexDirection: "column",
    justifyContent: "center",
}));

const StyledSortable = styled("span")(() => ({
    paddingRight: "5px",
    paddingBottom: "3px",
    minWidth: "150px",
}));

const UserHistoryModal = (props) => {
    const {
        handleOfficeDateChange,
        handleSaveHistory,
        handleShowModal,
        isLoading,
        name,
        showModal,
        userAccountKey,
        userOfficeHistoryData,
    } = props;

    const [key, setKey] = useState(null);
    const [date, setDate] = useState(null);
    const [type, setType] = useState(null);
    const [userAccountKeyLocal, setUserAccountKeyLocal] = useState(null);
    const [allowSave, setAllowSave] = useState(false);

    const handleUpdateDate = (key, date, type, userAccountKeyArg) => {
        setKey(key);
        setDate(date);
        setType(type);
        setUserAccountKeyLocal(userAccountKeyArg);
        setAllowSave(false);

        setTimeout(() => {
            submitDateChange();
        }, 1000);
    };

    const submitDateChange = () => {
        handleOfficeDateChange(key, date, type, userAccountKeyLocal);
        setKey(null);
        setDate(null);
        setType(null);
        setUserAccountKeyLocal(null);
        setAllowSave(true);
    };

    const saveHistory = () => {
        handleSaveHistory(userAccountKey);
        setAllowSave(false);
    };

    return (
        <Modal aria-labelledby="user-history-modal" aria-describedby="view-user-history" open={showModal}>
            <StyledModalContent>
                <h4 className="modal-title" style={{ paddingBottom: "25px", textAlign: "center" }}>
                    Office History for: {name}
                </h4>
                <Grid container justifyContent="center">
                    <Grid item xs style={{ overflowX: "hidden", minHeight: "25vh" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {schema.viewHeaders["userOfficeHistory"].map((x, i) => (
                                        <TableCell key={`thc-${i}`}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    width: "165px",
                                                }}
                                            >
                                                <StyledSortable>{x.name}</StyledSortable>
                                            </div>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {isLoading ? (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center">
                                            <CircularProgress color="primary" />
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    userOfficeHistoryData &&
                                    userOfficeHistoryData.map((x, i) =>
                                        row(x, i, isLoading, handleUpdateDate, userAccountKey, key, type, date)
                                    )
                                )}
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
                <Grid container justifyContent="flex-end">
                    <Grid item>
                        <Button
                            disabled={!allowSave}
                            color="primary"
                            variant="contained"
                            style={{ marginTop: "25px" }}
                            onClick={() => saveHistory(userAccountKey)}
                        >
                            Save
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            color="primary"
                            variant="outlined"
                            style={{ marginTop: "25px" }}
                            onClick={() => handleShowModal(false)}
                        >
                            Exit
                        </Button>
                    </Grid>
                </Grid>
            </StyledModalContent>
        </Modal>
    );
};

const row = (x, i, isLoading, handleUpdateDate, userAccountKey, updatingKey, updatingType, updatingDate) => {
    return isLoading ? null : (
        <TableRow key={`tr-${i}`} selectable="false">
            {schema.viewHeaders["userOfficeHistory"].map((y, k) => (
                <TableCell key={`trc-${k}`} style={{ width: "165px" }}>
                    {y.name === "End Date" && get(x, "currentOfficeFlg", false) === true ? (
                        <BSInput id="currentEndDate" value="Current" type="text" disabled={true} />
                    ) : includes(["End Date", "Start Date"], y.name) ? (
                        <BSInput
                            id="officeDate"
                            value={
                                get(x, "userOfficeHistoryKey", null) === updatingKey && y.prop === updatingType
                                    ? updatingDate
                                    : y.transform
                                      ? y.transform(x)
                                      : get(x, y.prop, "N/A")
                            }
                            onChange={(e) =>
                                handleUpdateDate(
                                    get(x, "userOfficeHistoryKey", null),
                                    e.target.value,
                                    y.prop,
                                    userAccountKey
                                )
                            }
                            type="date"
                            disabled={false}
                        />
                    ) : y.name === "Office" ? (
                        get(x, "office.officeMapping", null)
                    ) : y.transform ? (
                        y.transform(x)
                    ) : (
                        get(x, y.prop, "N/A")
                    )}
                </TableCell>
            ))}
        </TableRow>
    );
};

export default UserHistoryModal;
